import type { MaterialFormula, MaterialRate } from "./types.js";
import { ceilSafe, resolveInput, round2 } from "./util.js";

/** สร้างสูตรทั่วไป: ปริมาณ x อัตรา x (1+waste) จากตารางอัตรา */
export function genericFormula(rates: readonly MaterialRate[]): MaterialFormula {
  return (input) => {
    const { area, waste } = resolveInput(input);
    return rates.map((rt) => {
      const raw = area * rt.ratePerSqm * (rt.applyWaste ? 1 + waste : 1);
      return {
        key: rt.key,
        name_th: rt.name_th,
        qty: rt.applyWaste ? ceilSafe(raw) : round2(raw),
        unit: rt.unit,
        qty_basis: rt.applyWaste ? `area x ${rt.ratePerSqm} x (1+waste)` : `area x ${rt.ratePerSqm}`,
      };
    });
  };
}
